
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"M7 33v8h39V16l-10.5 9-13-4z"}}),_c('path',{staticClass:"i-Rectangle 20",attrs:{"stroke":"#234652","d":"M4.5 4.5h39v39h-39z"}}),_c('path',{staticClass:"i-Line 22",attrs:{"stroke":"#234652","stroke-dasharray":"1 4","d":"M17.5 4v40"}}),_c('path',{staticClass:"i-Line 23",attrs:{"stroke":"#234652","stroke-dasharray":"1 4","d":"M30.5 4v40"}}),_c('path',{staticClass:"i-Vector 7",attrs:{"stroke":"#234652","d":"m7 30 10.5-8 13 4L41 17"}})])
          )
        }
      }
    